export default {"src":"/_next/static/media/future.d942e204.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};